module.exports = __webpack_public_path__ + "static/media/prod2.102f5cc8.jpg";